import { EntityScope } from '../../../../shared/utils/enums';
import { FC, ReactElement } from 'react';
import { Modal } from 'react-bootstrap';
import EnduranceTrainingTypeForm from './EnduranceTrainingTypeForm';
import i18next from 'i18next';
import AppModal from '../app-modal/AppModal';
import { EnduranceTrainingTypeDto } from '../../../../shared/dtos/enduranceTrainingType.dto';
import { UnitDto } from '../../../../shared/dtos/unit.dto';

type EnduranceTrainingTypeModalProps = {
  show: boolean;
  entityScope: EntityScope;
  enduranceTrainingType?: EnduranceTrainingTypeDto;
  units: UnitDto[];
  onClose: () => void;
  onSave: () => void;
}

const EnduranceTrainingTypeModal: FC<EnduranceTrainingTypeModalProps> = ({
  show,
  entityScope,
  enduranceTrainingType,
  units,
  onClose,
  onSave
}: EnduranceTrainingTypeModalProps): ReactElement => {

  return (
    <AppModal show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>{i18next.t(enduranceTrainingType ? 'enduranceTrainingTypeModal.updateType' : 'enduranceTrainingTypeModal.createType')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <EnduranceTrainingTypeForm
          initialData={enduranceTrainingType}
          entityScope={entityScope}
          units={units}
          onClose={onClose}
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default EnduranceTrainingTypeModal;
